export default function setParamUrl(key: string, value: string): void {
  // update search params keeping the current search params
  const url = new URL(window.location.href);
  url.searchParams.set(key, value);
  window.history.replaceState({}, "", url.toString());
}
